/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Avatar,
    // Button,
    Card,
    Col,
    List,
    Row,
    Skeleton,
    // Input,
    Spin,
    // Drawer,
    // Popconfirm,
    Empty,
    Badge,
} from "antd";
import React, { useLayoutEffect, useState, useRef, useEffect } from "react";
import useMessagesHook from "./useMessagesHook";
import "./Messages.scss";
import {
    UserOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { isEmpty } from "lodash";
import LocumProfileCard from "./LocumProfileCard";
import noMessageIcon from "assets/img/message-remove.svg";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
//import { getFirebaseUserImageByUserId } from "firebaseConfig";

dayjs.extend(utc);
dayjs.extend(timezone);

//const { Search } = Input;

const Messages = () => {
    const {
        chatList,
        isLoading,
        open,
        setOpen,
        formatMessageTime,
        receiverObj,
        receiverLoader,
        allMessages,
        loadChatMessages,
        //onSearch,
    } = useMessagesHook();
    
    const headerRef = useRef(null);
    const contentRef = useRef(null);
    const chatEndRef = useRef(null);
    const [divHeight, setDivHeight] = useState(0);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const [userProfiles, setUserProfiles] = useState({}); // Store the profiles in a state object
    
    // useEffect(() => {
    //     const fetchUserProfiles = async () => {
    //         const profileData = {};
    //
    //         for (const user of chatList) {
    //             const picture = await getFirebaseUserImageByUserId(user.chat_user_id);
    //             profileData[user.chat_user_id] = picture; // Map user_id to the fetched profile picture
    //         }
    //
    //         setUserProfiles(profileData);
    //     };
    //
    //     fetchUserProfiles();
    // }, [chatList]); // Fetch profiles when `users` changes
    
    const updateDivHeight = () => {
        const headerHeight = headerRef.current ? headerRef.current.getBoundingClientRect().height : 0;
        const contentMargin = headerRef.current ? parseFloat(getComputedStyle(headerRef.current).marginBottom) : 0;
        const contentMarginTop = contentRef.current ? parseFloat(getComputedStyle(contentRef.current).marginTop) : 0;
        const contentPaddingBottom = contentRef.current ? parseFloat(getComputedStyle(contentRef.current).paddingBottom) : 0;
    
        const newHeight = window.innerHeight - contentMarginTop - contentPaddingBottom - headerHeight - contentMargin - 0; // Adjust the -40 as needed
        setDivHeight(newHeight);
        setIsSmallScreen(window.innerWidth > 767);
    };
    
    useLayoutEffect(() => {
        updateDivHeight();
        window.addEventListener("resize", updateDivHeight);
    
        return () => {
            window.removeEventListener("resize", updateDivHeight);
        };
    }, []);
    
    const scrollToBottom = () => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };
    
    useEffect(() => {
        scrollToBottom();
    }, [allMessages]);

    // const locationStr =
    //     locumUserData?.location?.locationName && locumUserData?.location?.address
    //         ? `${locumUserData?.location?.locationName}, ${locumUserData?.location?.address}`
    //         : locumUserData?.location?.locationName
    //         ? locumUserData?.location?.locationName
    //         : locumUserData?.location?.address
    //         ? locumUserData?.location?.address
    //         : "";

    return (
        <div ref={contentRef} className="content mb-0">
            <h2 ref={headerRef} className="page-main-title">
                Messages
            </h2>
            <Row gutter={[20,20]}>
                <Col
                    xl={8}
                    md={9}
                    xs={24}
                    className="messages-list-wrapper common-card-style"
                    style={isSmallScreen ? { height: divHeight } : {}}
                >
                    <Card>
                        {/* <Search
                            placeholder="Search"
                            onSearch={onSearch}
                            enterButton={<MyCustomIcon />}
                        /> */}
                        <List
                            className="demo-loadmore-list"
                            loading={isLoading}
                            itemLayout="horizontal"
                            // loadMore={loadMore}
                            dataSource={chatList}
                            renderItem={(item) => (
                                <List.Item
                                    className={`${
                                        receiverObj?._id === item?._id && "user-highlighted"
                                    }`}
                                    actions={[
                                        <div className="list-action-wrap">
                                            <div className="list-action-btn">
    
                                            </div>
                                            {!!item?.messageCount && (
                                                <Badge
                                                    className="msg-count"
                                                    count={item?.messageCount}
                                                />
                                            )}
                                        </div>,
                                    ]}
                                >
                                    <Skeleton avatar title={false} loading={item.loading} active>
                                        <List.Item.Meta
                                            avatar={
                                                <div
                                                    className={`${
                                                        item?.userStatus === "online" ? "online" : "offline"
                                                    }`}
                                                >
                                                    {/* {userProfiles[item.chat_user_id] && (
                                                        <Avatar src={userProfiles[item.chat_user_id]} />
                                                    )} */}
                                                    {/* <Avatar src={item.chat_user_profile_picture} /> */}
                                                </div>
                                            }
                                            title={<>{item?.locumUser?.[0]?.first_name ?? "[Deleted User]"} {item?.locumUser?.[0]?.last_name}</>}
                                            description={<span>{item?.businessUser?.[0]?.companyName ?? "[Deleted Company]"}</span>}
                                            onClick={() => loadChatMessages(item._id, item)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </Skeleton>
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
                <Col
                    xl={16}
                    md={15}
                    xs={24}
                    className="message-body common-card-style"
                    style={isSmallScreen ? { height: divHeight } : {}}
                >
                    <Card>
                        {receiverLoader && <Spin />}
                        {!isEmpty(receiverObj) ? (
                            <div className="message-details-wrapper">
                                <div className="message-header-part">
                                    <div
                                        className="author-details"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setOpen(true)}
                                    >
                                        {userProfiles[receiverObj.locumUserId] && (
                                                <Avatar
                                                src={userProfiles[receiverObj.locumUserId]}
                                                icon={<UserOutlined />}
                                            />
                                        )}
                                        <div className="author-bio-details">
                                            <div className="author-description">
                                                <h4>{receiverObj?.locumUser?.[0]?.first_name ?? "[Deleted User]"} {receiverObj?.locumUser?.[0]?.last_name}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="author-details"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setOpen(true)}
                                    >
                                        {userProfiles[receiverObj.businessUserId] && (
                                                <Avatar
                                                    src={userProfiles[receiverObj.businessUserId]}
                                                icon={<UserOutlined />}
                                            />
                                        )}
                                        <div className="author-bio-details">
                                            <div className="author-description">
                                                <h4>{receiverObj?.businessUser?.[0]?.companyName ?? "[Deleted Company]"}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="message-chat-screen">
                                    <div className="user-chat-area">
                                        <div className="history-chat">
                                            <ul className="chat-html-ul">
                                                {allMessages.length === 0 ? (
                                                    <div className="no-messages">
                                                        <img src={noMessageIcon} alt="no msg icon" />
                                                        <h5 className="no-msg-title">
                                                            No messages to display!!
                                                        </h5>
                                                    </div>
                                                ) : (
                                                    allMessages.map((msg, idx) => {
                                                        console.log( "Sender compare: ", msg.senderId, receiverObj.businessUserId, msg );
                                                        return (
                                                            <li
                                                                key={idx}
                                                                className={`list-group-item ${
                                                                    msg.senderId === receiverObj.businessUserId
                                                                        ? "right-side-cls"
                                                                        : "left-side-cls"
                                                                }`}
                                                            >
                                                                {msg.senderId !== receiverObj.businessUserId && (
                                                                    <div className="msg-user-img">
                                                                         {userProfiles[receiverObj.chat_user_id] && (
                                                                                <Avatar src={userProfiles[receiverObj.chat_user_id]} icon={<UserOutlined />} />
                                                                            )}
                                                                    </div>
                                                                )}
                                                                <div className="msg-chat-body">
                                                                    <p className="chat-msg">{msg.text}</p>
                                                                    {msg?.image_url && (
                                                                        <p className="uploaded-img-wrap">
                                                                            <Zoom>
                                                                                <img
                                                                                    src={msg.image_url}
                                                                                    alt="uploaded img"
                                                                                />
                                                                            </Zoom>
                                                                        </p>
                                                                    )}
                                                                    <span className="msg-user">
                                                                        {(msg.senderId === receiverObj.locumUserId) ? (
                                                                            <>{receiverObj?.locumUser?.[0]?.first_name ?? "[Deleted User]"} {receiverObj?.locumUser?.[0]?.last_name}</>
                                                                        ) : (
                                                                            <>{receiverObj?.businessUser?.[0]?.companyName ?? "[Deleted Company]"}</>
                                                                        )}
                                                                    </span>
                                                                    <span className="msg-time">
                                                                        {formatMessageTime(msg.createdAt)}
                                                                    </span>
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                )}
                                                <div ref={chatEndRef} />
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Empty />
                        )}
                    </Card>
                </Col>
                {/* <Drawer
                    title="Locum Info"
                    placement="right"
                    closable={true}
                    onClose={() => setOpen(false)}
                    open={open}
                >
                    <div className="locum-info-wrap">
                        <LocumProfileCard locumUserData={locumUserData} />
                    </div>
                </Drawer> */}
            </Row>
        </div>
    );
};

export default Messages;
